import { axiosInstance } from "./axiosInstance.js";

export default class API {

	constructor(){
        this.name = "API";
       
    }

    toString() {
        return this.name;
    }

    getCookie(name) {
        var r = document.cookie.match("\\b" + name + "=([^;]*)\\b");
        return r ? r[1] : null;
    }

    getFloorInfo() {
        return axiosInstance.get("api/v1/get-site-data/?site_identifier=site-2&floor_identifier=test");
    }

    checkSession() {
        return axiosInstance.get("api/v1/editor/check-session/");
    }

    getSiteData(siteIdentifier, floorIdentifier) {
        return axiosInstance.get("api/v1/editor/get-site/",{
            params: {
              site_identifier: siteIdentifier,
              floor_identifier: floorIdentifier
            },
        });
    }

    saveMapData(siteIdentifier, floorIdentifier, mapData){
        return axiosInstance.post("api/v1/editor/floor-data/",{
            site_identifier: siteIdentifier,
            floor_identifier: floorIdentifier,
            floor_data: mapData,
        });

        // let res = await axiosInstance.post("api/v1/editor/floor-data/", data);
        // if(res.data && (res.status==209 || res.status==200) ){
        //     return res;
        // }
        // return res.status;

    }

    async getPoints(siteIdentifier, orgIdentifier, q) {

        let res = await axiosInstance.get("api/v1/editor/search-point/",{
            params: {
              site_identifier: siteIdentifier,
              org_identifier: orgIdentifier,
              q : q
            },
        });

        return res.data;
    }

    async getBeacons(siteIdentifier, orgIdentifier, q) {

        let res = await axiosInstance.get("api/v1/editor/search-beacon/",{
            params: {
              site_identifier: siteIdentifier,
              org_identifier: orgIdentifier,
              q : q
            },
        });

        return res.data;
    }

    async validatePoint(siteIdentifier, orgIdentifier, floorIdentifier, pointName){
        var data = {
            'site_identifier': siteIdentifier,
            'org_identifier': orgIdentifier,
            'floor_identifier': floorIdentifier,
            'point_name': pointName
        };

        var headers = {
            'HTTP_X_CSRFTOKEN': this.getCookie('csrftoken')
        };

        //let res = await axiosInstance.post("api/v1/editor/validate-point/", data, {headers: headers})
        let res = await axiosInstance.post("api/v1/editor/validate-point/", data);
        
        return res.status == 200 ? true : false;
    }

    async validateBeacon(siteIdentifier, orgIdentifier, floorIdentifier,  params){
        var data = {
            'site_identifier': siteIdentifier,
            'org_identifier': orgIdentifier,
            'floor_identifier': floorIdentifier,
            'name': params.name,
            'major': params.major,
            'minor': params.minor

        };

        var headers = {
            'HTTP_X_CSRFTOKEN': this.getCookie('csrftoken')
        };

        //let res = await axiosInstance.post("api/v1/editor/validate-point/", data, {headers: headers})
        let res = await axiosInstance.post("api/v1/editor/validate-beacon/", data);
        
        return res.status == 200 ? true : false;
    }

    async saveData(siteIdentifier, floorIdentifier, mapData){
        var data = {
            'site_identifier': siteIdentifier,
            'floor_identifier': floorIdentifier,
            'floor_data': mapData,

        };

        let res = await axiosInstance.post("api/v1/editor/floor-data/", data);
        if(res.data && (res.status==209 || res.status==200) ){
            return res;
        }
        return res.status;

    }

    async saveFeedback(siteIdentifier,feedback){
        var data = {
            'site_identifier' : siteIdentifier,
            'feedback' : feedback
        };
        let res = await axiosInstance.post("api/v1/editor/report-error/", data).catch(err => {
                console.log("error");
                var res = {
                    status : 210
                };
                return res;
        });
        return res.status;
    }

    async getData(siteIdentifier, floorIdentifier){
        let res = await axiosInstance.get("api/v1/editor/floor-data/",{
            params: {
              site_identifier: siteIdentifier,
              floor_identifier: floorIdentifier
            },
        });
        return res.data;
    }

}